import React, { useEffect, useState } from 'react';
import PauseRoundedIcon from '@mui/icons-material/PauseRounded';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import heroAi from '../../assets/wisecursor-hero/hero-ai.jpg';
import heroMountain from '../../assets/wisecursor-hero/hero-mountain.jpg';
import heroAbstract from '../../assets/wisecursor-hero/hero-abstract.jpg';
import heroSecurity from '../../assets/wisecursor-hero/hero-security.jpg';

export const WISECURSOR_HERO_SLIDES = [
    { src: heroMountain, position: 'center center' },
    { src: heroAi, position: 'center center' },
    { src: heroAbstract, position: 'center center' },
    { src: heroSecurity, position: 'center center' },
];

const HeroBackgroundSlideshow = () => {
    const [activeSlide, setActiveSlide] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const [reduceMotion, setReduceMotion] = useState(false);

    useEffect(() => {
        if (typeof window.matchMedia !== 'function') return undefined;

        const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (!mediaQuery) return undefined;
        const updateMotionPreference = () => setReduceMotion(mediaQuery.matches);

        updateMotionPreference();
        mediaQuery.addEventListener?.('change', updateMotionPreference);

        return () => mediaQuery.removeEventListener?.('change', updateMotionPreference);
    }, []);

    useEffect(() => {
        if (isPaused || reduceMotion) return undefined;

        const interval = window.setInterval(() => {
            setActiveSlide((current) => (current + 1) % WISECURSOR_HERO_SLIDES.length);
        }, 7000);

        return () => window.clearInterval(interval);
    }, [isPaused, reduceMotion]);

    const slideshowPaused = isPaused || reduceMotion;

    return (
        <>
            <div className='wl-hero-slideshow' aria-hidden='true' data-testid='wisecursor-hero-slideshow'>
                {WISECURSOR_HERO_SLIDES.map((slide, index) => (
                    <img
                        key={slide.src}
                        className={`wl-hero-slideshow__image${index === activeSlide ? ' is-active' : ''}`}
                        src={slide.src}
                        alt=''
                        decoding='async'
                        fetchpriority={index === 0 ? 'high' : 'auto'}
                        style={{ objectPosition: slide.position }}
                    />
                ))}
            </div>
            {!reduceMotion && (
                <button
                    type='button'
                    className='wl-hero-slideshow__toggle'
                    aria-label={isPaused ? 'Play background slideshow' : 'Pause background slideshow'}
                    aria-pressed={isPaused}
                    onClick={() => setIsPaused((paused) => !paused)}
                >
                    {slideshowPaused ? <PlayArrowRoundedIcon /> : <PauseRoundedIcon />}
                </button>
            )}
        </>
    );
};

export default HeroBackgroundSlideshow;
